export const notificationLevel = { Error: "Error", Warning: "Warning", Success: "Success", Information: "Information" }
export const alertSeverity = { error: "error", warning: "warning", success: "success", info: "info" }
export const notificationType = {
    RepriceCorrection: "RepriceCorrection", FileNotReceived: "FileNotReceived",
    CutoffPassed: "CutoffPassed", PriorityZone: "PriorityZone",
    ParserError: "ParserError", HighPriorityZone: "HighPriorityZone",
    FileRequiresPreprocessing: "FileRequiresPreprocessing",
    MultipleFTPFilesFound: "MultipleFTPFilesFound",
    FulcrumProductMissing: "FulcrumProductMissing",
    NewProductAdded: "NewProductAdded",
    SRLProductNotFound: "SRLProductNotFound"
}

export const zoneStatus = {
    Draft: "Draft", SaveAsDraft: "Save as Draft",
    Publish: "Publish", NeedsReview: "Needs Review",
    ReadyForQC: "Ready for QC", Active: "Active",
    Inactive: "In-Active"
}
export const zoneStatusData = [{ id: 1, name: "Changes Found" },
{ id: 2, name: "Reviewed - No Changes" },
{ id: 3, name: "In Process" },
{ id: 4, name: "Complete" },
{ id: 5, name: "No Changes" },
{ id: 6, name: "Errors" }];

export const adjustmentZoneStatus = {
    All: { id: -1, name: "--All--" },
    Draft: { id: 1, name: "Draft" },
    ReadyForQC: { id: 2, name: "Ready for QC" },
    NeedsReview: { id: 3, name: "Needs Review" },
    Published: { id: 4, name: "Published" },
    Active: { id: 5, name: "Active" },
    InActive: { id: 6, name: "In-Active" }
};
export const adjustmentZoneStatuses = [adjustmentZoneStatus.All, adjustmentZoneStatus.Draft, adjustmentZoneStatus.ReadyForQC,
adjustmentZoneStatus.NeedsReview, adjustmentZoneStatus.Published, adjustmentZoneStatus.Active, adjustmentZoneStatus.InActive
];
export const dateFormat = "yyyy-MM-dd";
export const dateTimeFormat = "yyyy-MM-dd HH:mm:ss";
export const culture = "en-US";
export const timeZone = "America/New_York";
export const logLevelData = [{ id: 1, name: "Info" },
{ id: 2, name: "Warning" },
{ id: 3, name: "Error" }];
export const drawerWidth = 200;
export const yesNoValues = [{ id: true, name: "Yes" }, { id: false, name: "No" }];
export const colorPaletteKey = "colorPalette";
export const displayDensityKeys = { Small: "Small", Medium: "Medium", Large: "Large" };
export const displayDensityKey = "displayDensity";
export const displayDensity = [{ name: "Small", fontSize: 13, size: 'small', btnSize: 'small', margin: 'dense', variant: 'dense', dense: true },
{ name: "Medium", fontSize: 14, size: 'medium', btnSize: 'medium', margin: 'dense', variant: 'dense', dense: true },
{ name: "Large", fontSize: 15, size: 'medium', btnSize: 'large', margin: 'none', variant: 'regular', dense: false }];
export const statusColorCodes = { Green: "Green", Yellow: "Yellow", Red: "Red" };
export const channels = ["Consumer Loans", "Correspondent", "Deposits", "Retail", "Wholesale",];
export const fileTypes = ["Auto", "Clerk"];
export const fileSource = { Email: "Email", FTP: "FTP", Web: "Web", S3: "S3", Manual: "Manual", EmailLink: "Email Link", SecureEmail: "Secure Email" };
export const fileSources = [fileSource.Email, fileSource.FTP, fileSource.Web, fileSource.Manual, fileSource.S3, fileSource.EmailLink, fileSource.SecureEmail];
export const fileReprocessType = { All: { id: "All", name:"All Zones" }, Rates: { id: "Rate", name:"All Rate Zones" }, Adjustments: { id: "Adjustment", name:"All Adjustment Zones" } };
export const viewType = { Recent: "Recent", Archive: "Archive" };
export const userGroupPrefix = "fulcrum-";
export const fileTiming = { All: { id: false, name: "All" }, Expected: { id: true, name: "Expected" } };
export const userGroups = {
    Admin: userGroupPrefix + "admins", User: userGroupPrefix + "users", Auditor: userGroupPrefix + "auditor",
    Mortgage: userGroupPrefix + "mortgage", Deposits: userGroupPrefix + "deposits", 
    ConsumerLoans: userGroupPrefix + "consumer-loans",CommercialServices: userGroupPrefix + "commercial-services", 
    LendersBenchmark: userGroupPrefix + "lenders-benchmark",Indirect: userGroupPrefix + "indirect",
    CreditCard: userGroupPrefix + "credit-card",BusinessLending: userGroupPrefix + "business-lending",DepositFees: userGroupPrefix + "deposit-fees",
};
export const verticals = { Mortgage: 1, Deposits: 2, ConsumerLoans: 3, CommercialServices: 4, LendersBenchmark: 5, Indirect: 6, CreditCard: 7, BusinessLending: 8, DepositFees: 9 };
export const verticalUserGroupMapping = [{ Vertical: verticals.Mortgage, UserGroup: userGroups.Mortgage },
{ Vertical: verticals.Deposits, UserGroup: userGroups.Deposits },
{ Vertical: verticals.ConsumerLoans, UserGroup: userGroups.ConsumerLoans },
{ Vertical: verticals.CommercialServices, UserGroup: userGroups.CommercialServices },
{ Vertical: verticals.CreditCard, UserGroup: userGroups.CreditCard },
{ Vertical: verticals.BusinessLending, UserGroup: userGroups.BusinessLending },
{ Vertical: verticals.DepositFees, UserGroup: userGroups.DepositFees },
{ Vertical: verticals.LendersBenchmark, UserGroup: userGroups.LendersBenchmark, UserGroup: userGroups.Indirect }];
export const syncJobs = {
    MortgageLenders: "SyncMortgageLenders", DepositsLenders: "SyncDepositsLenders", LenderSheetProducts: "SyncLenderSheetProduct",
    GuideRates: "SyncGuideRates", DepositProducts: "SyncDepositProducts", ConsumerLoansLenders: "SyncConsumerLoansLenders",
    ConsumerLoansProductGroups: "SyncConsumerLoansProductGroups", ConsumerLoansProductTypes: "SyncConsumerLoansProductTypes", ConsumerLoansProducts: "SyncConsumerLoansProducts", Holidays:"SyncHolidaySchedule"
}
export const syncType = {
    MortgageLenders: "MortgageLenders", DepositsLenders: "DepositsLenders", LenderSheetProduct: "LenderSheetProduct",
    GuideRates: "GuideRates", DepositProducts: "DepositProducts", ConsumerLoansLenders: "ConsumerLoansLenders",
    ConsumerLoansProductGroups: "ConsumerLoansProductGroups", ConsumerLoansProductTypes: "ConsumerLoansProductTypes", ConsumerLoansProducts: "ConsumerLoansProducts", HolidaySchedule:"HolidaySchedule"
}
export const frequency = { Daily: 'Daily', Weekly: 'Weekly', Biweekly: 'Biweekly', Monthly: 'Monthly' };
export const frequencies = [{ id: frequency.Daily, name: frequency.Daily },
{ id: frequency.Weekly, name: frequency.Weekly },
{ id: frequency.Biweekly, name: frequency.Biweekly },
{ id: frequency.Monthly, name: frequency.Monthly }];
export const intervalType = { Range: 'Range', On: 'On' };
export const intervalTypes = [{ id: intervalType.Range, name: intervalType.Range },
{ id: intervalType.On, name: intervalType.On }];
export const biweekType = { Even: 'Even', Odd: 'Odd' };
export const biweekTypes = [{ id: biweekType.Even, name: biweekType.Even },
{ id: biweekType.Odd, name: biweekType.Odd }];
export const getDayOfMonths = () => {
    let dayOfMonths = [];
    for (var i = 1; i <= 31; i++) {
        dayOfMonths.push({ id: i, name: i + "" });
    }

    return dayOfMonths;
}
export const weekDay = {
    Sunday: { id: 1, name: 'Sunday' },
    Monday: { id: 2, name: 'Monday' },
    Tuesday: { id: 3, name: 'Tuesday' },
    Wednesday: { id: 4, name: 'Wednesday' },
    Thursday: { id: 5, name: 'Thursday' },
    Friday: { id: 6, name: 'Friday' },
    Saturday: { id: 7, name: 'Saturday' }
};
export const weekDays = [
    weekDay.Sunday,
    weekDay.Monday,
    weekDay.Tuesday,
    weekDay.Wednesday,
    weekDay.Thursday,
    weekDay.Friday,
    weekDay.Saturday
];
export const weekNumber = {
    One: { id: 1, name: '1st Week' },
    Two: { id: 2, name: '2nd Week' },
    Three: { id: 3, name: '3rd Week' },
    Four: { id: 4, name: '4th Week' }
};
export const weekNumbers = [
    weekNumber.One,
    weekNumber.Two,
    weekNumber.Three,
    weekNumber.Four
];
export const eventKeys = { VerticalNameUpdate: "VerticalNameUpdate", NewFileExport: "NewFileExport", HideLoader: "HideLoader", ShowLoader: "ShowLoader" };
export const sortDirection = { Ascending: { id: "Ascending", name: "Ascending" }, Descending: { id: "Descending", name: "Descending" } };
export const sortDirections = [sortDirection.Ascending, sortDirection.Descending];
export const emailRegex = /\S+@\S+\.\S+/;
